import React from 'react';
import { Sparkles, Award, Heart, Users } from 'lucide-react';
import SEO from '@/components/dubinko/SEO';
import { useSiteContent } from '@/hooks/useSiteContent';
import { resolveImage } from '@/lib/api';

export default function AboutPage() {
  const { content } = useSiteContent();
  const stats = [
    { v: '500+', l: 'Zadovoljnih klijenata' },
    { v: '5 god.', l: 'Iskustva u Nišu' },
    { v: '4.9/5', l: 'Prosečna ocena' },
    { v: '100%', l: 'Garancija zadovoljstva' },
  ];

  return (
    <main>
      <SEO
        title="O Dubinko timu"
        description="Mala porodična ekipa profesionalaca za dubinsko čišćenje u Nišu sa 5+ godina iskustva."
        path="/o-nama"
      />
      <section className="section-pad aurora-bg grain">
        <div className="container-x grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div>
            <span className="tag-pill">O nama</span>
            <h1 className="font-display text-5xl md:text-6xl font-extrabold mt-4 leading-tight">
              Mala porodična ekipa.<br />
              <span className="text-blue-700">Velika strast prema čistoći.</span>
            </h1>
            <p className="text-slate-600 mt-5 text-lg leading-relaxed">
              Dubinko je nastao iz jednostavne ideje – da svaka kuća, stan i kancelarija u Nišu zaslužuje
              prvoklasno dubinsko čišćenje. Više od pet godina dolazimo na vaše adrese sa profesionalnom opremom,
              ekološki prihvatljivim sredstvima i pažnjom za svaki detalj.
            </p>
            <p className="text-slate-600 mt-4 text-lg leading-relaxed">
              Naša misija je da vam vratimo vreme – dok mi vraćamo sjaj vašem prostoru.
            </p>
          </div>
          <div>
            <img src={resolveImage(content.about_image_url) || 'https://images.unsplash.com/photo-1581578731548-c64695cc6952?auto=format&fit=crop&w=1200&q=80'}
                 alt="Dubinko tim" loading="lazy"
                 className="rounded-3xl w-full aspect-[4/5] object-cover shadow-xl" />
          </div>
        </div>
      </section>

      <section className="py-16 bg-slate-50">
        <div className="container-x grid grid-cols-2 md:grid-cols-4 gap-6">
          {stats.map((s) => (
            <div key={s.l} className="bg-white rounded-3xl p-6 text-center border border-slate-200">
              <div className="font-display text-3xl md:text-4xl font-extrabold"
                style={{
                  background: 'linear-gradient(135deg, #059669 0%, #5B21B6 100%)',
                  WebkitBackgroundClip: 'text',
                  WebkitTextFillColor: 'transparent',
                }}>{s.v}</div>
              <div className="text-sm text-slate-600 mt-2">{s.l}</div>
            </div>
          ))}
        </div>
      </section>

      <section className="section-pad">
        <div className="container-x">
          <h2 className="font-display text-4xl md:text-5xl font-bold">{content.values_title || 'Naše vrednosti'}</h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mt-10">
            {(content.values && content.values.length ? content.values : [
              { t: 'Pažnja prema detaljima', d: 'Ono što drugi previde, mi ćemo očistiti dva puta.' },
              { t: 'Topao odnos', d: 'Tretiramo svaki dom kao da je naš.' },
              { t: 'Pouzdan tim', d: 'Naši profesionalci dolaze sa preporukama i obukom.' },
              { t: 'Garancija kvaliteta', d: 'Niste zadovoljni? Vraćamo se besplatno.' },
            ]).map((v, i) => {
              const meta = [
                { icon: Sparkles, color: 'text-emerald-600 bg-emerald-50' },
                { icon: Heart, color: 'text-purple-700 bg-purple-50' },
                { icon: Users, color: 'text-blue-700 bg-blue-50' },
                { icon: Award, color: 'text-amber-600 bg-amber-50' },
              ][i % 4];
              const I = meta.icon;
              return (
                <div key={v.t + i} className="service-card">
                  <div className={`icon-wrap ${meta.color}`}><I className="w-6 h-6" /></div>
                  <h3 className="font-display text-xl font-bold mt-4">{v.t}</h3>
                  <p className="text-slate-600 mt-2">{v.d}</p>
                </div>
              );
            })}
          </div>
        </div>
      </section>
    </main>
  );
}
